import { DEFAULT_STRATEGY, type StrategySettings } from "../../shared/contracts";

const PRESET_BUNDLES: Record<Exclude<StrategySettings["preset"], "custom">, StrategySettings> = {
  conservative: {
    preset: "conservative",
    amountUsd: 100,
    allocationPercent: 10,
    minimumNetEdgePercent: 1.5,
    grossTargetPercent: 3.4,
    stopDistancePercent: 0.5,
    maxHoldMinutes: 120,
    lossStreakLimit: 1,
    reinvestProfits: false,
    slippageAllowancePercent: 0.08,
  },
  standard: { ...DEFAULT_STRATEGY },
  aggressive: {
    preset: "aggressive",
    amountUsd: 300,
    allocationPercent: 40,
    minimumNetEdgePercent: 1,
    grossTargetPercent: 2.6,
    stopDistancePercent: 0.85,
    maxHoldMinutes: 60,
    lossStreakLimit: 3,
    reinvestProfits: false,
    slippageAllowancePercent: 0.18,
  },
};

export function applyStrategyPreset(
  current: StrategySettings,
  preset: StrategySettings["preset"],
): StrategySettings {
  if (preset === "custom") return { ...current, preset: "custom" };
  return { ...PRESET_BUNDLES[preset] };
}
